// services/setup.js — the chat-led setup (founder, 2026-09-28): where it
// stands, and answering it. The questions and every rule about them live on
// the server (Node Backend services/setup); each write answers with the setup
// as it now stands, so the chat's cards redraw from the server's word.
import { auth } from '../components/FirebaseConfig';
import { API_BASE } from '../apiSession';

const call = async (path, { method = 'GET', body } = {}) => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('Sign in to set up.');
  const res = await fetch(`${API_BASE}/api/setup${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const json = await res.json().catch(() => null);
  if (!res.ok || !json?.ok) throw new Error(json?.error || 'Could not reach your setup. Try again.');
  return json;
};

/** { groups, steps, progress: {done, total}, complete, applicationsReady, hasResume } */
export const fetchSetup = () => call('');

/** Saves one answer; the setup as it now stands. */
export const saveSetup = (key, value) => call(`/${encodeURIComponent(key)}`, { method: 'PUT', body: { value } });

/** "Looks right" on what the setup suggested for these keys; the setup as it now stands. */
export const confirmSetup = (keys) => call('/confirm', { method: 'POST', body: { keys } });
